import { memo } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';
import { ILeadTableHeaderProps } from '@/@types/leads';

export const LeadTableHeader = memo(function LeadTableHeader({
  allSelected,
  someSelected,
  onSelectAll,
  showRequestsColumn = false,
}: ILeadTableHeaderProps) {
  return (
    <div className="flex items-center h-11 px-6 bg-table-header border-b border-table-row-border">
      {/* Checkbox column */}
      <div className="flex items-center justify-center w-10">
        <Checkbox
          checked={allSelected}
          onCheckedChange={checked => onSelectAll(checked === true)}
          className={cn(someSelected && !allSelected && 'data-[state=checked]:bg-primary/50')}
        />
      </div>

      {/* Name column */}
      <div className="flex-1 min-w-0">
        <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
          Name
        </span>
      </div>

      {/* Source column */}
      <div className="w-[110px] pr-4">
        <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
          Source
        </span>
      </div>

      {/* Type column */}
      <div className="w-[100px] pr-4">
        <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
          Type
        </span>
      </div>

      {/* Temp column */}
      <div className="w-[88px] pr-4">
        <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
          Temp
        </span>
      </div>

      {/* Stage column */}
      <div className="w-[140px] pr-4">
        <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
          Stage
        </span>
      </div>

      {/* Last Contact column */}
      <div className="w-[100px]">
        <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
          Last Contact
        </span>
      </div>

      {/* Requests column — optional, hidden by default */}
      {showRequestsColumn && (
        <div className="w-[88px] pr-4">
          <span className="text-xs font-medium text-table-header-text uppercase tracking-wider">
            Requests
          </span>
        </div>
      )}

      {/* Actions column */}
      <div className="w-20" />
    </div>
  );
});
